<template lang="pug">
.title_star(v-bind:class='classes')
	.star
	h2.title
		//- Use vue slot to handle content
		//- https://v3.vuejs.org/guide/component-slots.html#slot-content
		slot(name='title') 預設值
	//- h5.title_en
	//- 	slot(name='title_en')
</template>

<script>
export default {
	props: {
		classes: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="stylus">
.title_star
	display: flex
	align-items: center
	margin-bottom: 50px
	.star
		width: 50px
		height: 50px
		margin-right: 0.5rem
		background-image: url('~@/assets/images/title_star.png')
		background-size: cover
		background-position: center center
	@media screen and (max-width: $screen-sm-max)
		margin-bottom: 20px
		.star
			width: 30px
			height: 30px
	.title, .title_en
		margin-bottom: 0
		color: white
		font-weight: 500
	.title_en
		margin: 0.5rem 0 0 0.5rem
	&.banner
		margin-bottom: 15vh
		@media screen and (max-width: $screen-sm-max)
			margin: 0
</style>
